import React, {Component}  from 'react';
import {connect} from 'react-redux';
import {Row,Col,Checkbox,message,Input,Radio,Select,Button,Icon,Modal,Upload,Tooltip} from 'antd';

import axios from 'axios'
import API from '../../../../API/api'
import storage from '../../../../utils/cookie'
import $ from '$'

class batchPushImage extends Component {
    state = {
        inited:false,

    }
    componentWillMount() {
        axios.post(API.UPLOAD_TOKEN).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.uptoken = res.data.uptoken
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }

    downloadFormat=()=>{

        var form = $("<form>");   //定义一个form表单
        form.attr('style', 'display:none');   //在form表单中添加查询参数
        form.attr('target', '');
        form.attr('method', 'post');
        form.attr('action', API.ENTRY_TASH_IMPORT_FORMAT);
        var input1 = $('<input>');
        // input1.attr('type', 'hidden');
        // input1.attr('name', 'assist_id');
        // input1.attr('value',this.props.assistCurrent);
        $('body').append(form);  //将表单放置在web中
        form.append(input1);   //将查询参数控件提交到表单上
        form.submit();
    }


    render(){
        const token = storage.getData('token');
        let _this = this
        //上传知识点树
        const props = {
            name: 'file',
            action: `${API.ENTRY_TASH_BATCH_ADD}&token=${token}`,
            data:{
                task_id:this.props.task_id
            },
            beforeUpload(file) {
                let xls = false
                if(file.type === ''){if(/.xls/.exec(file.name)){xls = true}}
                const notExcel = !(file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'||file.type === 'application/vnd.ms-excel'||xls);
                if(notExcel){
                    message.error('上传文件格式不是Excel')
                    return false
                }
                _this.setState({loadding:true,loaddingPre:false})
            },
            onChange(info) {
                if (info.file.status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if (info.file.status === 'done') {
                    if(info.file.response.code === 0){
                        message.success(`${info.file.name} 上传成功`);
                        _this.setState({
                            loadding:false, loaddingEnd:true,
                            ability_num:info.file.response.data.ability_num,
                            display_num: info.file.response.data.display_num,
                            total:info.file.response.data.total,
                        })
                    }
                    else{
                        message.error(`${info.file.response.message}`);
                        _this.setState({loadding:false})
                    }
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} 上传失败`);
                    _this.setState({loadding:false})
                }
            },
        };

        return(
            <div style={{display:'inline-block',marginLeft:10}}>

                    <Button style={{verticalAlign:'middle'}}  onClick={()=>{this.setState({loaddingPre:true})}} type="primary">
                        批量导入题目
                    </Button>

                <Modal
                    title={'选择导入文件'}
                    visible={this.state.loaddingPre}
                    footer={''}
                    width={500}
                    onCancel={() => {this.setState({loaddingPre:false})}}>
                    <div style={{position:'relative'}}>
                        <div  style={{fontSize:15,textAlign:'center'}}>
                            <div  style={{width:400,textAlign:'left',margin: '0 auto'}}>
                                <div style={{margin:'10px 0'}}>
                                    <span>选择导入题型：</span>
                                    <Select value={'1'}>
                                        <Select.Option  value={'1'}>口算</Select.Option>
                                    </Select>
                                </div>

                                <div style={{margin:'10px 0'}}>
                                    <span>选择导入文件：</span>
                                    {
                                        <Upload
                                            {...props}
                                            showUploadList={false}
                                        >
                                            <Button type={'primary'}>
                                                <Icon type="upload" />
                                            </Button>
                                        </Upload>

                                    }
                                    <Tooltip
                                        placement="right"
                                        title={<div>
                                            <div>
                                                <div>1. 引导语使用【】隔开；</div>
                                                <div>2. 问号“？”表示公式空；</div>
                                                <div>{`3. frac{n/m}表示分数；`}</div>
                                                <div>4. 能力标签和展示类型输入ID；</div>
                                                <div>5. 多个答案使用逗号隔开；</div>

                                            </div>
                                        </div>

                                        }
                                        mouseEnterDelay={0.5}>
                                        <Icon type="question-circle-o" style={{marginLeft:20,color:'#1890ff',cursor: 'help'}} />
                                    </Tooltip>
                                </div>

                                <div style={{margin:'10px 0'}}>
                                    <span>导入模版下载：</span>
                                    <Button onClick={this.downloadFormat} type={'primary'}>
                                        <Icon type="download" />
                                    </Button>
                                </div>
                            </div>

                        </div>
                    </div>

                </Modal>
                <Modal
                    title={'提示'}
                    visible={this.state.loadding}
                    footer={''}
                    width={300}
                    onCancel={() => {}}>
                    <div style={{position:'relative'}}>
                        <div style={{fontSize:19,color:'#108ee9',textAlign:'center'}}>
                            题目正在导入中。。。

                        </div>
                    </div>

                </Modal>
                <Modal
                    title={'导入结果'}
                    visible={this.state.loaddingEnd}
                    width={600}
                    onCancel={() => {this.setState({loaddingEnd:false});window.location.reload()}}
                    onOk={() => {this.setState({loaddingEnd:false});window.location.reload()}}>
                    <div style={{position:'relative'}}>
                        <div style={{fontSize:14,textAlign:'center'}}>
                            文件中总共有题目：<span style={{fontWeight:700}}>{this.state.total}</span> 个
                        </div>
                        {/*<div style={{fontSize:14,color:'#108ee9',textAlign:'center'}}>*/}
                            {/*导入成功的题目有：<span>{1}</span>个，其中有知识点：<span>{1}</span>个，*/}
                        {/*</div>*/}
                        <div style={{fontSize:14,textAlign:'center'}}>
                            有能力标签的题目：<span style={{fontWeight:700}}>{this.state.ability_num}</span> 个，有展示类型的题目：<span style={{fontWeight:700}}>{this.state.display_num}</span> 个，
                        </div>
                    </div>

                </Modal>
            </div>
        );
    }
}
const mapStateTopProps = (state) => {
    return {

    };
}

const mapDispatchToProps = dispatch => {
    return {

    }
};


export default connect (mapStateTopProps,mapDispatchToProps)(batchPushImage)


// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_list/batchPushQuestion/batchPushQuestion.js